import React, { Component } from "react"
import { GridProps } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledH4 = styled.h4`
  flex: 1 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(34,36,38,.1);
  margin-bottom: 0 !important;
`;

class HomeRightHeader extends Component<GridProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyledH4 {...rest}>
          {children}
        </StyledH4>
    )
  }
}

export default HomeRightHeader;
